(function () {
  const MOBILE_QUERY = '(max-width: 990px)';
  const TOP_THRESHOLD = 8;
  const SCROLL_END_MS = 150;
  const SCROLL_CLASS = 'sfw-header-scroll-up';
  const DEEP_SCROLL_CLASS = 'sfw-header-scroll-deep';
  const DEEP_SCROLL_THRESHOLD = 120;

  let previousScrollTop = 0;
  let scrollEndTimer = null;
  let mobileMedia = null;

  function isMobile() {
    return mobileMedia && mobileMedia.matches;
  }

  function updateHeaderHeight() {
    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    const headerSection = document.querySelector('.section-header');
    const target = headerGroup || headerSection;

    if (!target) return;

    document.documentElement.style.setProperty('--header-height', `${target.offsetHeight}px`);
  }

  function setScrollUpState(active) {
    const root = document.documentElement;
    const hasClass = root.classList.contains(SCROLL_CLASS);
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= DEEP_SCROLL_THRESHOLD) {
      root.classList.add(DEEP_SCROLL_CLASS);
    } else {
      root.classList.remove(DEEP_SCROLL_CLASS);
    }

    if (active && !hasClass) {
      root.classList.add(SCROLL_CLASS);
      requestAnimationFrame(updateHeaderHeight);
    } else if (!active && hasClass) {
      root.classList.remove(SCROLL_CLASS);
      requestAnimationFrame(updateHeaderHeight);
    }
  }

  function clearScrollUp() {
    if (scrollEndTimer) {
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = null;
    }
    document.documentElement.classList.remove(SCROLL_CLASS);
    requestAnimationFrame(updateHeaderHeight);
  }

  function onScroll() {
    if (!isMobile()) {
      clearScrollUp();
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop <= TOP_THRESHOLD) {
      clearScrollUp();
      document.documentElement.classList.remove(DEEP_SCROLL_CLASS);
      previousScrollTop = scrollTop;
      return;
    }

    if (scrollTop < previousScrollTop) {
      setScrollUpState(true);
    } else if (scrollTop > previousScrollTop) {
      setScrollUpState(false);
    }

    previousScrollTop = scrollTop;

    if (scrollEndTimer) {
      window.clearTimeout(scrollEndTimer);
    }

    scrollEndTimer = window.setTimeout(() => {
      setScrollUpState(false);
      scrollEndTimer = null;
    }, SCROLL_END_MS);
  }

  function onMediaChange() {
    if (!isMobile()) {
      clearScrollUp();
      document.documentElement.classList.remove(DEEP_SCROLL_CLASS);
      previousScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }
    updateHeaderHeight();
  }

  function init() {
    mobileMedia = window.matchMedia(MOBILE_QUERY);
    previousScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.addEventListener('scroll', onScroll, { passive: true });
    mobileMedia.addEventListener('change', onMediaChange);
    window.addEventListener('resize', updateHeaderHeight, { passive: true });
    window.addEventListener('orientationchange', updateHeaderHeight);

    updateHeaderHeight();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
